"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var manuf = {
    "AAV": "Volkswagen",
    "AC5": "Hyundai",
    "ADD": "Hyundai",
    "AFA": "Ford",
    "AHT": "Toyota",
    "JA3": "Mitsubishi",
    "JA4": "Mitsubishi",
    "JA": "Isuzu",
    "JD": "Daihatsu",
    "JF": "Fuji Heavy Industries (Subaru)",
    "JH": "Honda",
    "JK": "Kawasaki (motorcycles)",
    "JL5": "Mitsubishi Fuso",
    "JMB": "Mitsubishi Motors",
    "JMY": "Mitsubishi Motors",
    "JMZ": "Mazda",
    "JN": "Nissan",
    "JS": "Suzuki",
    "JT": "Toyota",
    "JY": "Yamaha (motorcycles)",
    "KL": "Daewoo General Motors",
    "KM": "Hyundai",
    "KMY": "Daelim (motorcycles)",
    "KM1": "Hyosung (motorcycles)",
    "KN": "Kia",
    "KNM": "Renault Samsung",
    "KPA": "SsangYong",
    "KPT": "SsangYong",
    "LAE": "Jinan Qingqi Motorcycle",
    "LAN": "Changzhou Yamasaki Motorcycle",
    "LBB": "Zhejiang Qianjiang Motorcycle (Keeway/Generic)",
    "LBE": "Beijing Hyundai",
    "LBM": "Zongshen Piaggio",
    "LBP": "Chongqing Jainshe Yamaha (motorcycles)",
    "LB2": "Geely Motorcycles",
    "LCE": "Hangzhou Chunfeng Motorcycles (CFMOTO)",
    "LDC": "Dong Feng Peugeot Citroen (DPCA)",
    "LDD": "Dandong Huanghai Automobile",
    "LDN": "SouEast Motor",
    "LDY": "Zhongtong Coach",
    "LET": "Jiangling-Isuzu Motors",
    "LE4": "Beijing Benz",
    "LFB": "FAW (busses)",
    "LFG": "Taizhou Chuanl Motorcycle Manufacturing",
    "LFP": "FAW (passenger vehicles)",
    "LFT": "FAW (trailers)",
    "LFV": "FAW-Volkswagen",
    "LFW": "FAW JieFang",
    "LFY": "Changshu Light Motorcycle Factory",
    "LGB": "Dong Feng (DFM)",
    "LGH": "Qoros (formerly Dong Feng (DFM))",
    "LGX": "BYD Auto",
    "LHB": "Beijing Automotive Industry Holding",
    "LH1": "FAW-Haima",
    "LJC": "JAC",
    "LJ1": "JAC",
    "LKL": "Suzhou King Long",
    "LL6": "Hunan Changfeng Manufacture Joint-Stock",
    "LL8": "Linhai (ATV)",
    "LMC": "Suzuki Hong Kong (motorcycles)",
    "LPR": "Yamaha Hong Kong (motorcycles)",
    "LSG": "SAIC General Motors",
    "LSJ": "SAIC MG",
    "LSV": "SAIC Volkswagen",
    "LSY": "Brilliance Zhonghua",
    "LTV": "Toyota Tian Jin",
    "LUC": "Guangqi Honda",
    "LVS": "Ford Chang An",
    "LVV": "Chery",
    "LVZ": "Dong Feng Sokon Motor Company (DFSK)",
    "LZM": "MAN",
    "LZE": "Isuzu Guangzhou",
    "LZG": "Shaanxi Automobile Group",
    "LZP": "Zhongshan Guochi Motorcycle (Baotian)",
    "LZY": "Yutong Zhengzhou",
    "LZZ": "Chongqing Shuangzing Mech & Elec (Howo)",
    "L4B": "Xingyue Group (motorcycles)",
    "L5C": "KangDi (ATV)",
    "L5K": "Zhejiang Yongkang Easy Vehicle",
    "L5N": "Zhejiang Taotao (ATV & motorcycles)",
    "L5Y": "Merato Motorcycle Taizhou Zhongneng",
    "L85": "Zhejiang Yongkang Huabao Electric Appliance",
    "L8X": "Zhejiang Summit Huawin Motorcycle",
    "MAB": "Mahindra & Mahindra",
    "MAC": "Mahindra & Mahindra",
    "MAJ": "Ford",
    "MAK": "Honda Siel Cars",
    "MAL": "Hyundai",
    "MAT": "Tata Motors",
    "MA1": "Mahindra & Mahindra",
    "MA3": "Suzuki (Maruti)",
    "MA6": "GM",
    "MA7": "Mitsubishi (formerly Honda)",
    "MBH": "Suzuki (Maruti)",
    "MBJ": "Toyota",
    "MBR": "Mercedes-Benz",
    "MB1": "Ashok Leyland",
    "MCA": "Fiat",
    "MCB": "GM",
    "MC2": "Volvo Eicher commercial vehicles limited.",
    "MDH": "Nissan",
    "MD2": "Bajaj Auto",
    "MD9": "Shuttle Cars",
    "MEE": "Renault",
    "MEX": "Volkswagen",
    "MHF": "Toyota",
    "MHR": "Honda",
    "MLC": "Suzuki",
    "MLH": "Honda",
    "MMB": "Mitsubishi",
    "MMC": "Mitsubishi",
    "MMM": "Chevrolet",
    "MMS": "Suzuki",
    "MMT": "Mitsubishi",
    "MM8": "Mazda",
    "MNB": "Ford",
    "MNT": "Nissan",
    "MPA": "Isuzu",
    "MP1": "Isuzu",
    "MRH": "Honda",
    "MR0": "Toyota",
    "MS0": "KIA",
    "MS3": "Suzuki Motor Co., Ltd.",
    "NLA": "Honda",
    "NLE": "Mercedes-Benz Truck",
    "NLH": "Hyundai Assan",
    "NLT": "TEMSA",
    "NMB": "Mercedes-Benz Buses",
    "NMC": "BMC",
    "NM0": "Ford",
    "NM4": "Tofaş",
    "NMT": "Toyota",
    "NNA": "Isuzu",
    "PE1": "Ford",
    "PE3": "Mazda",
    "PL1": "Proton",
    "PNA": "NAZA (Peugeot)",
    "RA1": "Steyr Trucks International FZE",
    "RFB": "Kymco",
    "RFG": "Sanyang SYM",
    "RFL": "Adly",
    "RFT": "CPI",
    "RF3": "Aeon Motor",
    "SAD": "Jaguar (F-Pace)",
    "SAL": "Land Rover",
    "SAJ": "Jaguar",
    "SAR": "Rover",
    "SB1": "Toyota",
    "SBM": "McLaren",
    "SCA": "Rolls Royce",
    "SCB": "Bentley",
    "SCC": "Lotus Cars",
    "SCE": "DeLorean Motor Cars N. Ireland",
    "SCF": "Aston",
    "SDB": "Peugeot (formerly Talbot)",
    "SED": "General Motors Luton Plant",
    "SEY": "LDV",
    "SFA": "Ford",
    "SFD": "Alexander Dennis",
    "SHH": "Honda",
    "SHS": "Honda",
    "SJN": "Nissan",
    "SKF": "Vauxhall",
    "SLP": "JCB Research",
    "SMT": "Triumph Motorcycles",
    "SUF": "Fiat Auto",
    "SUL": "FSC",
    "SUP": "FSO-Daewoo",
    "SUU": "Solaris Bus & Coach",
    "SWV": "TA-NO",
    "TCC": "Micro Compact Car AG (smart 1998-1999)",
    "TDM": "QUANTYA Swiss Electric Movement",
    "TK9": "SOR buses",
    "TMA": "Hyundai Motor Manufacturing",
    "TMB": "Škoda",
    "TMK": "Karosa",
    "TMP": "Škoda trolleybuses",
    "TMT": "Tatra",
    "TM9": "Škoda trolleybuses",
    "TNE": "TAZ",
    "TN9": "Karosa",
    "TRA": "Ikarus Bus",
    "TRU": "Audi",
    "TSE": "Ikarus Egyedi Autobuszgyar",
    "TSM": "Suzuki",
    "TW1": "Toyota Caetano",
    "TYA": "Mitsubishi Trucks",
    "TYB": "Mitsubishi Trucks",
    "UU1": "Renault Dacia",
    "UU3": "ARO",
    "UU6": "Daewoo",
    "U5Y": "Kia Motors",
    "U6Y": "Kia Motors",
    "VAG": "Magna Steyr Puch",
    "VAN": "MAN",
    "VBK": "KTM (Motorcycles)",
    "VF1": "Renault",
    "VF2": "Renault",
    "VF3": "Peugeot",
    "VF4": "Talbot",
    "VF6": "Renault (Trucks & Buses)",
    "VF7": "Citroën",
    "VF8": "Matra",
    "VF9": "Bugatti",
    "795": "Bugatti",
    "VG5": "MBK (motorcycles)",
    "VLU": "Scania",
    "VN1": "SOVAB",
    "VNE": "Irisbus",
    "VNK": "Toyota",
    "VNV": "Renault-Nissan",
    "VSA": "Mercedes-Benz",
    "VSE": "Suzuki (Santana Motors)",
    "VSK": "Nissan",
    "VSS": "SEAT",
    "VSX": "Opel",
    "VS6": "Ford",
    "VS7": "Citroën",
    "VS9": "Carrocerias Ayats",
    "VTH": "Derbi (motorcycles)",
    "VTL": "Yamaha (motorcycles)",
    "VTT": "Suzuki (motorcycles)",
    "VV9": "TAURO",
    "VWA": "Nissan",
    "VWV": "Volkswagen",
    "VX1": "Zastava / Yugo Serbia",
    "WAG": "Neoplan",
    "WAU": "Audi",
    "WA1": "Audi SUV",
    "WBA": "BMW",
    "WBS": "BMW M",
    "WBW": "BMW",
    "WBY": "BMW",
    "WDA": "Daimler",
    "WDB": "Mercedes-Benz",
    "WDC": "DaimlerChrysler",
    "WDD": "Mercedes-Benz",
    "WDF": "Mercedes-Benz (commercial vehicles)",
    "WEB": "Evobus GmbH (Mercedes-Bus)",
    "WJM": "Iveco Magirus",
    "WF0": "Ford",
    "WKE": "Fahrzeugwerk Bernard Krone GmbH & Co. KG",
    "WKK": "Kässbohrer/Setra",
    "WMA": "MAN",
    "WME": "smart",
    "WMW": "MINI",
    "WMX": "Mercedes-AMG",
    "WP0": "Porsche",
    "WP1": "Porsche SUV",
    "W09": "RUF",
    "W0L": "Opel",
    "W0V": "Opel",
    "WUA": "quattro GmbH",
    "WVG": "Volkswagen MPV/SUV",
    "WVW": "Volkswagen",
    "WV1": "Volkswagen Commercial Vehicles",
    "WV2": "Volkswagen Bus/Van",
    "WV3": "Volkswagen Trucks",
    "XLB": "Volvo (NedCar)",
    "XLE": "Scania",
    "XLR": "DAF (trucks)",
    "XL9": "Spyker",
    "363": "Spyker",
    "XMC": "Mitsubishi (NedCar)",
    "XTA": "Lada/AvtoVAZ",
    "XTC": "KAMAZ",
    "XTH": "GAZ",
    "XTT": "UAZ/Sollers",
    "XTY": "LiAZ",
    "XUF": "General Motors",
    "XUU": "AvtoTor (General Motors SKD)",
    "XW8": "Volkswagen Group",
    "XWB": "UZ-Daewoo",
    "XWE": "AvtoTor (Hyundai-Kia SKD)",
    "X1M": "PAZ",
    "X4X": "AvtoTor (BMW SKD)",
    "X7L": "Renault AvtoFramos",
    "X7M": "Hyundai TagAZ",
    "YBW": "Volkswagen",
    "YB1": "Volvo Trucks",
    "YCM": "Mazda",
    "YE2": "Van Hool (buses)",
    "YH2": "BRP (Lynx snowmobiles)",
    "YK1": "Saab-Valmet",
    "YS2": "Scania AB",
    "YS3": "Saab",
    "YS4": "Scania Bus",
    "YTN": "Saab NEVS",
    "YT9": "Koenigsegg",
    "007": "Koenigsegg",
    "034": "Carvia",
    "YU7": "Husaberg (motorcycles)",
    "YV1": "Volvo Cars",
    "YV4": "Volvo Cars",
    "YV2": "Volvo Trucks",
    "YV3": "Volvo Buses",
    "Y3M": "MAZ",
    "Y6D": "Zaporozhets/AvtoZAZ",
    "ZAA": "Autobianchi",
    "ZAM": "Maserati",
    "ZAP": "Piaggio/Vespa/Gilera",
    "ZAR": "Alfa Romeo",
    "ZBN": "Benelli",
    "ZCG": "Cagiva SpA / MV Agusta",
    "ZCF": "Iveco",
    "ZDM": "Ducati Motor Holdings SpA",
    "ZDF": "Ferrari Dino",
    "ZD0": "Yamaha",
    "ZD3": "Beta Motor",
    "ZD4": "Aprilia",
    "ZFA": "Fiat",
    "ZFC": "Fiat V.I.",
    "ZFF": "Ferrari",
    "ZGU": "Moto Guzzi",
    "ZHW": "Lamborghini",
    "ZJM": "Malaguti",
    "ZJN": "Innocenti",
    "ZKH": "Husqvarna Motorcycles",
    "ZLA": "Lancia",
    "ZOM": "OM",
    "Z8M": "Marussia",
    "Z8T": "Peugeot / Citroen (Kaluga)",
    "1B3": "Dodge",
    "1C3": "Chrysler",
    "1C4": "Chrysler",
    "1C6": "Chrysler",
    "1D3": "Dodge",
    "1FA": "Ford Motor Company",
    "1FB": "Ford Motor Company",
    "1FC": "Ford Motor Company",
    "1FD": "Ford Motor Company",
    "1FM": "Ford Motor Company",
    "1FT": "Ford Motor Company",
    "1FU": "Freightliner",
    "1FV": "Freightliner",
    "1F9": "FWD Corp.",
    "1G": "General Motors",
    "1GC": "Chevrolet Truck",
    "1GT": "GMC Truck",
    "1G1": "Chevrolet",
    "1G2": "Pontiac",
    "1G3": "Oldsmobile",
    "1G4": "Buick",
    "1G6": "Cadillac",
    "1G8": "Saturn",
    "1GM": "Pontiac",
    "1GY": "Cadillac",
    "1H": "Honda",
    "1HD": "Harley-Davidson",
    "1J4": "Jeep",
    "1J8": "Jeep",
    "1L": "Lincoln",
    "1ME": "Mercury",
    "1M1": "Mack Truck",
    "1M2": "Mack Truck",
    "1M3": "Mack Truck",
    "1M4": "Mack Truck",
    "1M9": "Mynatt Truck & Equipment",
    "1N": "Nissan",
    "1NX": "NUMMI",
    "1P3": "Plymouth",
    "1R9": "Roadrunner Hay Squeeze",
    "1VW": "Volkswagen",
    "1XK": "Kenworth",
    "1XP": "Peterbilt",
    "1YV": "Mazda (AutoAlliance International)",
    "1ZV": "Ford (AutoAlliance International)",
    "2A4": "Chrysler",
    "2BP": "Bombardier Recreational Products",
    "2B3": "Dodge",
    "2B7": "Dodge",
    "2C3": "Chrysler",
    "2CN": "CAMI",
    "2D3": "Dodge",
    "2FA": "Ford Motor Company",
    "2FB": "Ford Motor Company",
    "2FC": "Ford Motor Company",
    "2FM": "Ford Motor Company",
    "2FT": "Ford Motor Company",
    "2FU": "Freightliner",
    "2FV": "Freightliner",
    "2FZ": "Sterling",
    "2Gx": "General Motors",
    "2G1": "Chevrolet",
    "2G2": "Pontiac",
    "2G3": "Oldsmobile",
    "2G4": "Buick",
    "2G9": "Gnome Homes",
    "2HG": "Honda",
    "2HK": "Honda",
    "2HJ": "Honda",
    "2HM": "Hyundai",
    "2M": "Mercury",
    "2NV": "Nova Bus",
    "2P3": "Plymouth",
    "2T": "Toyota",
    "2TP": "Triple E LTD",
    "2V4": "Volkswagen",
    "2V8": "Volkswagen",
    "2WK": "Western Star",
    "2WL": "Western Star",
    "2WM": "Western Star",
    "3C4": "Chrysler",
    "3D3": "Dodge",
    "3D4": "Dodge",
    "3FA": "Ford Motor Company",
    "3FE": "Ford Motor Company",
    "3G": "General Motors",
    "3H": "Honda",
    "3JB": "BRP (all-terrain vehicles)",
    "3MD": "Mazda",
    "3MZ": "Mazda",
    "3N": "Nissan",
    "3P3": "Plymouth",
    "3VW": "Volkswagen",
    "4F": "Mazda",
    "4JG": "Mercedes-Benz",
    "4M": "Mercury",
    "4RK": "Nova Bus",
    "4S": "Subaru-Isuzu Automotive",
    "4T": "Toyota",
    "4T9": "Lumen Motors",
    "4UF": "Arctic Cat Inc.",
    "4US": "BMW",
    "4UZ": "Frt-Thomas Bus",
    "4V1": "Volvo",
    "4V2": "Volvo",
    "4V3": "Volvo",
    "4V4": "Volvo",
    "4V5": "Volvo",
    "4V6": "Volvo",
    "4VL": "Volvo",
    "4VM": "Volvo",
    "4VZ": "Volvo",
    "538": "Zero Motorcycles",
    "5F": "Honda Alabama",
    "5J": "Honda Ohio",
    "5L": "Lincoln",
    "5N1": "Nissan",
    "5NP": "Hyundai",
    "5T": "Toyota - trucks",
    "5YJ": "Tesla, Inc.",
    "6AB": "MAN",
    "6F4": "Nissan Motor Company",
    "6F5": "Kenworth",
    "6FP": "Ford Motor Company",
    "6G1": "General Motors-Holden (post Nov 2002)",
    "6G2": "Pontiac (GTO & G8)",
    "6H8": "General Motors-Holden (pre Nov 2002)",
    "6MM": "Mitsubishi Motors",
    "6T1": "Toyota Motor Corporation",
    "6U9": "Privately Imported car",
    "8AD": "Peugeot",
    "8AF": "Ford Motor Company",
    "8AG": "Chevrolet",
    "8AJ": "Toyota",
    "8AK": "Suzuki",
    "8AP": "Fiat",
    "8AW": "Volkswagen",
    "8A1": "Renault",
    "8GD": "Peugeot",
    "8GG": "Chevrolet",
    "935": "Citroën",
    "936": "Peugeot",
    "93H": "Honda",
    "93R": "Toyota",
    "93U": "Audi",
    "93V": "Audi",
    "93X": "Mitsubishi Motors",
    "93Y": "Renault",
    "94D": "Nissan",
    "9BD": "Fiat",
    "9BF": "Ford Motor Company",
    "9BG": "Chevrolet",
    "9BM": "Mercedes-Benz",
    "9BR": "Toyota",
    "9BS": "Scania",
    "9BW": "Volkswagen",
    "9FB": "Renault",
    "WB1": "BMW Motorrad of North America",
    "MHA": 'PT. Central Sole Agency (Volvo)',
    "1V1": 'Volkswagen USA (commercials)',
    "4TL": "Toyota",
    "JMG": "Mazda",
    "3GE": "General Motors Mexico",
    "5TP": "Toyota USA - trucks",
    "5F5": "Honda USA-Alabama",
    "5LH": "Lincoln",
    "1GP": "General Motors USA",
    "KL9": "Daewoo General Motors South Korea",
    "JMV": "Mazda",
    "JM5": "Mazda",
    "JFL": "Fuji Heavy Industries",
    "5FX": "Honda USA-Alabama",
    "1HK": "Honda USA",
    "JAL": "Isuzu",
    "1NT": "Nissan USA",
    "2M7": "Mercury",
    "JSC": "Suzuki",
    "JM1": "Mazda",
    "1N2": "Nissan USA",
    "2TK": "Toyota Canada",
    "1LZ": "Lincoln USA",
    "2MC": "Mercury",
    "JMM": "Mazda",
    "2GZ": "General Motors Canada",
    "JMT": "Mazda",
    "3NM": "Nissan Mexico",
    "4ML": "Mercury",
    "5FL": "Honda USA-Alabama",
    "1NM": "Nissan USA",
    "5FM": "Honda USA-Alabama",
    "JSV": "Suzuki",
    "JM6": "Mazda",
    "5L9": "Lincoln",
    "1N6": "Nissan USA",
    "JAT": "Isuzu",
    "1GX": "General Motors USA",
    "JNZ": "Nissan",
    "2GD": "General Motors Canada",
    "4T5": "Toyota",
    "JHM": "Honda",
    "4TZ": "Toyota",
    "JNJ": "Nissan",
    "1H7": "Honda USA",
    "JT0": "Toyota",
    "1GV": "General Motors USA",
    "4SM": "Subaru-Isuzu Automotive",
    "JAH": "Isuzu",
    "4FA": "Mazda USA",
    "JTE": "Toyota",
    "4TU": "Toyota",
    "2G6": "General Motors Canada",
    "4MF": "Mercury",
    "4ST": "Subaru-Isuzu Automotive",
    "JAA": "Isuzu",
    "1H4": "Honda USA",
    "4S7": "Subaru-Isuzu Automotive",
    "JTD": "Toyota",
    "4SR": "Subaru-Isuzu Automotive",
    "2GK": "General Motors Canada",
    "5FB": "Honda USA-Alabama",
    "5LV": "Lincoln",
    "2M1": "Mercury",
    "4SB": "Subaru-Isuzu Automotive",
    "4MK": "Mercury",
    "2TR": "Toyota Canada",
    "JN3": "Nissan",
    "1L8": "Lincoln USA",
    "4TH": "Toyota",
    "3GK": "General Motors Mexico",
    "JKY": "Kawasaki",
    "1HR": "Honda USA",
    "3GR": "General Motors Mexico",
    "JAW": "Isuzu",
    "1HT": "Honda USA",
    "4TX": "Toyota",
    "3G4": "General Motors Mexico",
    "4F7": "Mazda USA",
    "JS2": "Suzuki",
    "3G9": "General Motors Mexico",
    "3NL": "Nissan Mexico",
    "JSR": "Suzuki",
    "1LL": "Lincoln USA",
    "JA7": "Isuzu",
    "1HJ": "Honda USA",
    "KLE": "Daewoo General Motors South Korea",
    "JKU": "Kawasaki",
    "4SK": "Subaru-Isuzu Automotive",
    "JF6": "Fuji Heavy Industries",
    "3HH": "Honda Mexico",
    "2GC": "General Motors Canada",
    "5TN": "Toyota USA - trucks",
    "JS3": "Suzuki",
    "3N0": "Nissan Mexico",
    "5LT": "Lincoln",
    "4SC": "Subaru-Isuzu Automotive",
    "JKT": "Kawasaki",
    "L56": "Renault Samsung",
    "4T3": "Toyota",
    "2MT": "Mercury",
    "JKR": "Kawasaki",
    "JM3": "Mazda",
    "4T4": "Toyota",
    "JSH": "Suzuki",
    "4FU": "Mazda USA",
    "5T4": "Toyota USA - trucks",
    "5L8": "Lincoln",
    "2TL": "Toyota Canada",
    "JKL": "Kawasaki",
    "4F2": "Mazda USA",
    "JSN": "Suzuki",
    "JF9": "Fuji Heavy Industries",
    "3HW": "Honda Mexico",
    "1NF": "Nissan USA",
    "1NV": "Nissan USA",
    "3HG": "Honda Mexico",
    "JND": "Nissan",
    "3GT": "General Motors Mexico",
    "3H3": "Honda Mexico",
    "JAX": "Isuzu",
    "JNA": "Nissan",
    "KL3": "Daewoo General Motors South Korea",
    "1N5": "Nissan USA",
    "3GC": "General Motors Mexico",
    "3HN": "Honda Mexico",
    "4SA": "Subaru-Isuzu Automotive",
    "JN8": "Nissan",
    "2GW": "General Motors Canada",
    "4FC": "Mazda USA",
    "JT3": "Toyota",
    "JAS": "Isuzu",
    "4FY": "Mazda USA",
    "4TE": "Toyota",
    "JN2": "Nissan",
    "3N1": "Nissan Mexico",
    "3HV": "Honda Mexico",
    "KNA": "Kia",
    "2TD": "Toyota Canada",
    "JK6": "Kawasaki",
    "4SS": "Subaru-Isuzu Automotive",
    "JAB": "Isuzu",
    "JNT": "Nissan",
    "KLL": "Daewoo General Motors South Korea",
    "1HG": "Honda USA",
    "3GH": "General Motors Mexico",
    "2MF": "Mercury",
    "2TW": "Toyota Canada",
    "JNY": "Nissan",
    "1LM": "Lincoln USA",
    "5TY": "Toyota USA - trucks",
    "JSM": "Suzuki",
    "3NU": "Nissan Mexico",
    "5TC": "Toyota USA - trucks",
    "5T1": "Toyota USA - trucks",
    "4S1": "Subaru-Isuzu Automotive",
    "1LS": "Lincoln USA",
    "JM4": "Mazda",
    "5TD": "Toyota USA - trucks",
    "5FV": "Honda USA-Alabama",
    "JAP": "Isuzu",
    "JTY": "Toyota",
    "3GY": "General Motors Mexico",
    "5LD": "Lincoln",
    "2TJ": "Toyota Canada",
    "4SZ": "Subaru-Isuzu Automotive",
    "JF1": "Fuji Heavy Industries",
    "JNB": "Nissan",
    "2GP": "General Motors Canada",
    "JSB": "Suzuki",
    "JTB": "Toyota",
    "4MP": "Mercury",
    "JAD": "Isuzu",
    "4T8": "Toyota",
    "JN5": "Nissan",
    "5T9": "Toyota USA - trucks",
    "1GJ": "General Motors USA",
    "3GU": "General Motors Mexico",
    "JKC": "Kawasaki",
    "JK1": "Kawasaki",
    "4FB": "Mazda USA",
    "JAU": "Isuzu",
    "JMD": "Mazda",
    "3GX": "General Motors Mexico",
    "2GL": "General Motors Canada",
    "3HX": "Honda Mexico",
    "3GF": "General Motors Mexico",
    "5LS": "Lincoln",
    "2MM": "Mercury",
    "JST": "Suzuki",
    "2MA": "Mercury",
    "1H1": "Honda USA",
    "2GN": "General Motors Canada",
    "3GL": "General Motors Mexico",
    "1HW": "Honda USA",
    "4F4": "Mazda USA",
    "2GH": "General Motors Canada",
    "3G3": "General Motors Mexico",
    "4M6": "Mercury",
    "1N3": "Nissan USA",
    "JA8": "Isuzu",
    "JAE": "Isuzu",
    "JFG": "Fuji Heavy Industries",
    "KNC": "Kia",
    "3NG": "Nissan Mexico",
    "1HA": "Honda USA",
    "1GW": "General Motors USA",
    "JM9": "Mazda",
    "3HE": "Honda Mexico",
    "1NK": "Nissan USA",
    "1L2": "Lincoln USA",
    "2M3": "Mercury",
    "5L5": "Lincoln",
    "JTA": "Toyota",
    "4M8": "Mercury",
    "JAR": "Isuzu",
    "2TT": "Toyota Canada",
    "1NA": "Nissan USA",
    "4SN": "Subaru-Isuzu Automotive",
    "2MN": "Mercury",
    "4M4": "Mercury",
    "4TB": "Toyota",
    "4M1": "Mercury",
    "JFF": "Fuji Heavy Industries",
    "2T5": "Toyota Canada",
    "5T5": "Toyota USA - trucks",
    "5TR": "Toyota USA - trucks",
    "JS0": "Suzuki",
    "JS1": "Suzuki",
    "JS8": "Suzuki",
    "5LW": "Lincoln",
    "JNC": "Nissan",
    "4F3": "Mazda USA",
    "4MJ": "Mercury",
    "1ND": "Nissan USA",
    "3N4": "Nissan Mexico",
    "3N3": "Nissan Mexico",
    "4FK": "Mazda USA",
    "5LX": "Lincoln",
    "1GB": "General Motors USA",
    "5FW": "Honda USA-Alabama",
    "2MR": "Mercury",
    "4FL": "Mazda USA",
    "1H0": "Honda USA",
    "4SH": "Subaru-Isuzu Automotive",
    "3GJ": "General Motors Mexico",
    "1HE": "Honda USA",
    "1LA": "Lincoln USA",
    "2GB": "General Motors Canada",
    "4FE": "Mazda USA",
    "JKP": "Kawasaki",
    "1L9": "Lincoln USA",
    "1N1": "Nissan USA",
    "JMX": "Mazda",
    "1L5": "Lincoln USA",
    "JN0": "Nissan",
    "2T0": "Toyota Canada",
    "KLW": "Daewoo General Motors South Korea",
    "5TV": "Toyota USA - trucks",
    "2MW": "Mercury",
    "KLC": "Daewoo General Motors South Korea",
    "4FP": "Mazda USA",
    "2T4": "Toyota Canada",
    "JS4": "Suzuki",
    "JK9": "Kawasaki",
    "JAJ": "Isuzu",
    "4TG": "Toyota",
    "3HY": "Honda Mexico",
    "4T0": "Toyota",
    "JN7": "Nissan",
    "JSK": "Suzuki",
    "JN6": "Nissan",
    "3NY": "Nissan Mexico",
    "4TY": "Toyota",
    "3NK": "Nissan Mexico",
    "2MY": "Mercury",
    "5LJ": "Lincoln",
    "JTL": "Toyota",
    "4TW": "Toyota",
    "4M0": "Mercury",
    "4SW": "Subaru-Isuzu Automotive",
    "3HS": "Honda Mexico",
    "2TN": "Toyota Canada",
    "4M2": "Mercury",
    "4FZ": "Mazda USA",
    "1LF": "Lincoln USA",
    "2M4": "Mercury",
    "2GE": "General Motors Canada",
    "JNU": "Nissan",
    "1GS": "General Motors USA",
    "KL1": "Daewoo General Motors South Korea",
    "JNE": "Nissan",
    "2M2": "Mercury",
    "JKV": "Kawasaki",
    "4TT": "Toyota",
    "3H6": "Honda Mexico",
    "4S0": "Subaru-Isuzu Automotive",
    "4MV": "Mercury",
    "JNS": "Nissan",
    "KLX": "Daewoo General Motors South Korea",
    "1NZ": "Nissan USA",
    "5TG": "Toyota USA - trucks",
    "JMH": "Mazda",
    "5TF": "Toyota USA - trucks",
    "5TZ": "Toyota USA - trucks",
    "4SG": "Subaru-Isuzu Automotive",
    "JSY": "Suzuki",
    "JA2": "Isuzu",
    "KLK": "Daewoo General Motors South Korea",
    "5F2": "Honda USA-Alabama",
    "1LG": "Lincoln USA",
    "KLZ": "Daewoo General Motors South Korea",
    "JAF": "Isuzu",
    "1GZ": "General Motors USA",
    "4SX": "Subaru-Isuzu Automotive",
    "5TS": "Toyota USA - trucks",
    "JK7": "Kawasaki",
    "JMC": "Mazda",
    "5TH": "Toyota USA - trucks",
    "5FE": "Honda USA-Alabama",
    "KLP": "Daewoo General Motors South Korea",
    "2T8": "Toyota Canada",
    "KLV": "Daewoo General Motors South Korea",
    "4SV": "Subaru-Isuzu Automotive",
    "1HU": "Honda USA",
    "5LL": "Lincoln",
    "5TB": "Toyota USA - trucks",
    "3GD": "General Motors Mexico",
    "JAK": "Isuzu",
    "JK5": "Kawasaki",
    "1LY": "Lincoln USA",
    "3N9": "Nissan Mexico",
    "4FM": "Mazda USA",
    "4MS": "Mercury",
    "4F8": "Mazda USA",
    "3GA": "General Motors Mexico",
    "JNW": "Nissan",
    "2MJ": "Mercury",
    "JTR": "Toyota",
    "JSX": "Suzuki",
    "KL0": "Daewoo General Motors South Korea",
    "JFK": "Fuji Heavy Industries",
    "1LP": "Lincoln USA",
    "2TM": "Toyota Canada",
    "3NR": "Nissan Mexico",
    "JT6": "Toyota",
    "1HS": "Honda USA",
    "5LA": "Lincoln",
    "3G0": "General Motors Mexico",
    "5L6": "Lincoln",
    "3GZ": "General Motors Mexico",
    "5FJ": "Honda USA-Alabama",
    "1GF": "General Motors USA",
    "2MV": "Mercury",
    "4MX": "Mercury",
    "5FH": "Honda USA-Alabama",
    "JFV": "Fuji Heavy Industries",
    "2TZ": "Toyota Canada",
    "JSF": "Suzuki",
    "5T8": "Toyota USA - trucks",
    "1LB": "Lincoln USA",
    "KLS": "Daewoo General Motors South Korea",
    "JHL": "Honda",
    "JTH": "Toyota",
    "4FX": "Mazda USA",
    "1GU": "General Motors USA",
    "4T7": "Toyota",
    "1H9": "Honda USA",
    "3HL": "Honda Mexico",
    "2TU": "Toyota Canada",
    "JSG": "Suzuki",
    "JN4": "Nissan",
    "1LH": "Lincoln USA",
    "1GH": "General Motors USA",
    "KLM": "Daewoo General Motors South Korea",
    "5LF": "Lincoln",
    "2M6": "Mercury",
    "2TG": "Toyota Canada",
    "5FZ": "Honda USA-Alabama",
    "3NA": "Nissan Mexico",
    "JFC": "Fuji Heavy Industries",
    "4M5": "Mercury",
    "3NS": "Nissan Mexico",
    "JNG": "Nissan",
    "5TU": "Toyota USA - trucks",
    "2MZ": "Mercury",
    "2M5": "Mercury",
    "JNM": "Nissan",
    "3GS": "General Motors Mexico",
    "3NF": "Nissan Mexico",
    "JSS": "Suzuki",
    "JKZ": "Kawasaki",
    "JKH": "Kawasaki",
    "3H2": "Honda Mexico",
    "JKG": "Kawasaki",
    "JA9": "Isuzu",
    "4MZ": "Mercury",
    "4FG": "Mazda USA",
    "1NW": "Nissan USA",
    "1GA": "General Motors USA",
    "4F6": "Mazda USA",
    "JM7": "Mazda",
    "4FJ": "Mazda USA",
    "2ME": "Mercury",
    "4TN": "Toyota",
    "1L1": "Lincoln USA",
    "3G7": "General Motors Mexico",
    "JF4": "Fuji Heavy Industries",
    "5FA": "Honda USA-Alabama",
    "1H2": "Honda USA",
    "JSU": "Suzuki",
    "2MX": "Mercury",
    "JMF": "Mazda",
    "5FN": "Honda USA-Alabama",
    "1NP": "Nissan USA",
    "1NB": "Nissan USA",
    "2GF": "General Motors Canada",
    "3NB": "Nissan Mexico",
    "JS5": "Suzuki",
    "JT4": "Toyota",
    "1LR": "Lincoln USA",
    "1GK": "General Motors USA",
    "JK0": "Kawasaki",
    "JSA": "Suzuki",
    "3HA": "Honda Mexico",
    "JFE": "Fuji Heavy Industries",
    "4F0": "Mazda USA",
    "4SU": "Subaru-Isuzu Automotive",
    "1GD": "General Motors USA",
    "JTV": "Toyota",
    "JAM": "Isuzu",
    "1L6": "Lincoln USA",
    "JKD": "Kawasaki",
    "3HU": "Honda Mexico",
    "3NV": "Nissan Mexico",
    "JFH": "Fuji Heavy Industries",
    "KLT": "Daewoo General Motors South Korea",
    "4SL": "Subaru-Isuzu Automotive",
    "3ND": "Nissan Mexico",
    "1HM": "Honda USA",
    "5FD": "Honda USA-Alabama",
    "4MD": "Mercury",
    "4MT": "Mercury",
    "JTM": "Toyota",
    "JF7": "Fuji Heavy Industries",
    "5F3": "Honda USA-Alabama",
    "1LC": "Lincoln USA",
    "4SJ": "Subaru-Isuzu Automotive",
    "JFN": "Fuji Heavy Industries",
    "JA0": "Isuzu",
    "KL6": "Daewoo General Motors South Korea",
    "KNB": "Kia",
    "JTJ": "Toyota",
    "JKS": "Kawasaki",
    "2MB": "Mercury",
    "5LP": "Lincoln",
    "JSD": "Suzuki",
    "KL5": "Daewoo General Motors South Korea",
    "JSJ": "Suzuki",
    "5T7": "Toyota USA - trucks",
    "JTF": "Toyota",
    "JT9": "Toyota",
    "KL7": "Daewoo General Motors South Korea",
    "JTN": "Toyota",
    "2GS": "General Motors Canada",
    "1N8": "Nissan USA",
    "1G9": "General Motors USA",
    "JTS": "Toyota",
    "5FT": "Honda USA-Alabama",
    "3HB": "Honda Mexico",
    "1LV": "Lincoln USA",
    "1N9": "Nissan USA",
    "JNL": "Nissan",
    "1LJ": "Lincoln USA",
    "1HX": "Honda USA",
    "4MR": "Mercury",
    "4TR": "Toyota",
    "3NC": "Nissan Mexico",
    "JTX": "Toyota",
    "3GM": "General Motors Mexico",
    "JFT": "Fuji Heavy Industries",
    "3N2": "Nissan Mexico",
    "KLR": "Daewoo General Motors South Korea",
    "4MC": "Mercury",
    "1G7": "General Motors USA",
    "1N4": "Nissan USA",
    "1HL": "Honda USA",
    "JT5": "Toyota",
    "JNN": "Nissan",
    "4SY": "Subaru-Isuzu Automotive",
    "5TT": "Toyota USA - trucks",
    "1NL": "Nissan USA",
    "JFZ": "Fuji Heavy Industries",
    "JNF": "Nissan",
    "JAZ": "Isuzu",
    "JKF": "Kawasaki",
    "JKE": "Kawasaki",
    "2G8": "General Motors Canada",
    "5TW": "Toyota USA - trucks",
    "4MU": "Mercury",
    "2GV": "General Motors Canada",
    "1HN": "Honda USA",
    "JS7": "Suzuki",
    "5FK": "Honda USA-Alabama",
    "5F1": "Honda USA-Alabama",
    "JS9": "Suzuki",
    "JNV": "Nissan",
    "4T1": "Toyota",
    "1L3": "Lincoln USA",
    "3HF": "Honda Mexico",
    "1HZ": "Honda USA",
    "2T2": "Toyota Canada",
    "1HP": "Honda USA",
    "KLU": "Daewoo General Motors South Korea",
    "2TA": "Toyota Canada",
    "3G6": "General Motors Mexico",
    "4TP": "Toyota",
    "5L0": "Lincoln",
    "3HK": "Honda Mexico",
    "3HT": "Honda Mexico",
    "4FN": "Mazda USA",
    "1N7": "Nissan USA",
    "JAC": "Isuzu",
    "3GP": "General Motors Mexico",
    "JT8": "Toyota",
    "4TJ": "Toyota",
    "2T7": "Toyota Canada",
    "KL8": "Daewoo General Motors South Korea",
    "JTZ": "Toyota",
    "4T6": "Toyota",
    "2ML": "Mercury",
    "JF0": "Fuji Heavy Industries",
    "1L0": "Lincoln USA",
    "4M9": "Mercury",
    "3H9": "Honda Mexico",
    "JTT": "Toyota",
    "4FW": "Mazda USA",
    "JFJ": "Fuji Heavy Industries",
    "4F1": "Mazda USA",
    "5TA": "Toyota USA - trucks",
    "JKX": "Kawasaki",
    "4FV": "Mazda USA",
    "5FG": "Honda USA-Alabama",
    "JKN": "Kawasaki",
    "5F4": "Honda USA-Alabama",
    "4S6": "Subaru-Isuzu Automotive",
    "1HY": "Honda USA",
    "JT1": "Toyota",
    "3N8": "Nissan Mexico",
    "2T3": "Toyota Canada",
    "1LN": "Lincoln USA",
    "JFX": "Fuji Heavy Industries",
    "JSZ": "Suzuki",
    "1LE": "Lincoln USA",
    "5FF": "Honda USA-Alabama",
    "1GL": "General Motors USA",
    "JK2": "Kawasaki",
    "4S4": "Subaru-Isuzu Automotive",
    "5LM": "Lincoln",
    "2TE": "Toyota Canada",
    "JTG": "Toyota",
    "JK8": "Kawasaki",
    "1LU": "Lincoln USA",
    "JK3": "Kawasaki",
    "5TX": "Toyota USA - trucks",
    "3G8": "General Motors Mexico",
    "JS6": "Suzuki",
    "JA6": "Isuzu",
    "3GV": "General Motors Mexico",
    "5LE": "Lincoln",
    "1GR": "General Motors USA",
    "1N0": "Nissan USA",
    "1H6": "Honda USA",
    "4S9": "Subaru-Isuzu Automotive",
    "5L7": "Lincoln",
    "5T0": "Toyota USA - trucks",
    "4T2": "Toyota",
    "4ME": "Mercury",
    "5L3": "Lincoln",
    "1GN": "General Motors USA",
    "3HJ": "Honda Mexico",
    "2TV": "Toyota Canada",
    "KLF": "Daewoo General Motors South Korea",
    "1G0": "General Motors USA",
    "2MS": "Mercury",
    "4MG": "Mercury",
    "3H1": "Honda Mexico",
    "JSE": "Suzuki",
    "5TE": "Toyota USA - trucks",
    "1LD": "Lincoln USA",
    "JA5": "Isuzu",
    "5LY": "Lincoln",
    "4S2": "Subaru-Isuzu Automotive",
    "4FD": "Mazda USA",
    "4S8": "Subaru-Isuzu Automotive",
    "JFU": "Fuji Heavy Industries",
    "2GR": "General Motors Canada",
    "4SP": "Subaru-Isuzu Automotive",
    "2GJ": "General Motors Canada",
    "3N5": "Nissan Mexico",
    "5FS": "Honda USA-Alabama",
    "JSL": "Suzuki",
    "KMH": "Hyundai",
    "2M8": "Mercury",
    "JFD": "Fuji Heavy Industries",
    "JML": "Mazda",
    "2TB": "Toyota Canada",
    "4M7": "Mercury",
    "1NY": "Nissan USA",
    "JAY": "Isuzu",
    "1HH": "Honda USA",
    "5LK": "Lincoln",
    "JMN": "Mazda",
    "3H4": "Honda Mexico",
    "5L4": "Lincoln",
    "3NH": "Nissan Mexico",
    "5LN": "Lincoln",
    "JTC": "Toyota",
    "2GT": "General Motors Canada",
    "3H5": "Honda Mexico",
    "5LG": "Lincoln",
    "JKK": "Kawasaki",
    "1NN": "Nissan USA",
    "2TY": "Toyota Canada",
    "4SE": "Subaru-Isuzu Automotive",
    "5LB": "Lincoln",
    "3HC": "Honda Mexico",
    "3H7": "Honda Mexico",
    "5TM": "Toyota USA - trucks",
    "4S3": "Subaru-Isuzu Automotive",
    "1NC": "Nissan USA",
    "4TA": "Toyota",
    "5F9": "Honda USA-Alabama",
    "5TJ": "Toyota USA - trucks",
    "5FP": "Honda USA-Alabama",
    "JNH": "Nissan",
    "4SF": "Subaru-Isuzu Automotive",
    "4FS": "Mazda USA",
    "5F7": "Honda USA-Alabama",
    "1HF": "Honda USA",
    "1LT": "Lincoln USA",
    "1H3": "Honda USA",
    "JNK": "Nissan",
    "JM0": "Mazda",
    "3NX": "Nissan Mexico",
    "2M9": "Mercury",
    "2MK": "Mercury",
    "2MD": "Mercury",
    "2MU": "Mercury",
    "5LU": "Lincoln",
    "KLB": "Daewoo General Motors South Korea",
    "2TX": "Toyota Canada",
    "JF3": "Fuji Heavy Industries",
    "2MP": "Mercury",
    "JFP": "Fuji Heavy Industries",
    "3GB": "General Motors Mexico",
    "5L1": "Lincoln",
    "2M0": "Mercury",
    "JAN": "Isuzu",
    "2GA": "General Motors Canada",
    "4MM": "Mercury",
    "SU9": "Solaris Bus & Coach (Poland)",
    "5T6": "Toyota USA - trucks",
    "2MG": "Mercury",
    "JKA": "Kawasaki",
    "3HP": "Honda Mexico",
    "2GM": "General Motors Canada",
    "4SD": "Subaru-Isuzu Automotive",
    "JFS": "Fuji Heavy Industries",
    "KLY": "Daewoo General Motors South Korea",
    "4MB": "Mercury",
    "1GE": "General Motors USA",
    "JNP": "Nissan",
    "KLJ": "Daewoo General Motors South Korea",
    "JMR": "Mazda",
    "JHG": "Honda",
    "4MW": "Mercury",
    "5FR": "Honda USA-Alabama",
    "JKW": "Kawasaki",
    "1H5": "Honda USA",
    "5T3": "Toyota USA - trucks",
    "KLG": "Daewoo General Motors South Korea",
    "4FF": "Mazda USA",
    "JA1": "Isuzu",
    "JTK": "Toyota",
    "4MA": "Mercury",
    "4S5": "Subaru-Isuzu Automotive",
    "5FY": "Honda USA-Alabama",
    "3G1": "General Motors Mexico",
    "KL2": "Daewoo General Motors South Korea",
    "5F0": "Honda USA-Alabama",
    "3HR": "Honda Mexico",
    "1L4": "Lincoln USA",
    "5FC": "Honda USA-Alabama",
    "KLN": "Daewoo General Motors South Korea",
    "5F6": "Honda USA-Alabama",
    "1NR": "Nissan USA",
    "5L2": "Lincoln",
    "5T2": "Toyota USA - trucks",
    "4FH": "Mazda USA",
    "JFA": "Fuji Heavy Industries",
    "1H8": "Honda USA",
    "3G5": "General Motors Mexico",
    "2T9": "Toyota Canada",
    "4TC": "Toyota",
    "4MY": "Mercury",
    "1NU": "Nissan USA",
    "5LC": "Lincoln",
    "KLD": "Daewoo General Motors South Korea",
    "JT2": "Toyota",
    "JTW": "Toyota",
    "JAG": "Isuzu",
    "KL4": "Daewoo General Motors South Korea",
    "4FR": "Mazda USA",
    "3NP": "Nissan Mexico",
    "JMA": "Mazda",
    "2G0": "General Motors Canada",
    "5LZ": "Lincoln",
    "JFR": "Fuji Heavy Industries",
    "JM2": "Mazda",
    "5TL": "Toyota USA - trucks",
    "JN9": "Nissan",
    "2G5": "General Motors Canada",
    "3H0": "Honda Mexico",
    "JF8": "Fuji Heavy Industries",
    "JKJ": "Kawasaki",
    "JSP": "Suzuki",
    "2TF": "Toyota Canada",
    "3HM": "Honda Mexico",
    "3NW": "Nissan Mexico",
    "2T6": "Toyota Canada",
    "1L7": "Lincoln USA",
    "3N7": "Nissan Mexico",
    "JFM": "Fuji Heavy Industries",
    "JMJ": "Mazda",
    "JM8": "Mazda",
    "1GG": "General Motors USA",
    "JFY": "Fuji Heavy Industries",
    "JFB": "Fuji Heavy Industries",
    "3NE": "Nissan Mexico",
    "1NG": "Nissan USA",
    "1NE": "Nissan USA",
    "5TK": "Toyota USA - trucks",
    "2TS": "Toyota Canada",
    "4F9": "Mazda USA",
    "4MN": "Mercury",
    "JTP": "Toyota",
    "4MH": "Mercury",
    "KM8": "Hyundai",
    "JTU": "Toyota",
    "4TF": "Toyota",
    "JMS": "Mazda",
    "3NN": "Nissan Mexico",
    "2TC": "Toyota Canada",
    "4TV": "Toyota",
    "2T1": "Toyota Canada",
    "2GX": "General Motors Canada",
    "JK4": "Kawasaki",
    "JMU": "Mazda",
    "JF5": "Fuji Heavy Industries",
    "JNX": "Nissan",
    "1G5": "General Motors USA",
    "JNR": "Nissan",
    "JF2": "Fuji Heavy Industries",
    "JKB": "Kawasaki",
    "JME": "Mazda",
    "2GU": "General Motors Canada",
    "4TK": "Toyota",
    "1HV": "Honda USA",
    "JMP": "Mazda",
    "KLH": "Daewoo General Motors South Korea",
    "4TD": "Toyota",
    "2MH": "Mercury",
    "3HZ": "Honda Mexico",
    "JAV": "Isuzu",
    "2G7": "General Motors Canada",
    "JT7": "Toyota",
    "JKM": "Kawasaki",
    "3N6": "Nissan Mexico",
    "1LX": "Lincoln USA",
    "JMK": "Mazda",
    "3NT": "Nissan Mexico",
    "5F8": "Honda USA-Alabama",
    "KLA": "Daewoo General Motors South Korea",
    "2GG": "General Motors Canada",
    "3GW": "General Motors Mexico",
    "4F5": "Mazda USA",
    "1LW": "Lincoln USA",
    "4M3": "Mercury",
    "3GN": "General Motors Mexico",
    "1NS": "Nissan USA",
    "1NH": "Nissan USA",
    "2TH": "Toyota Canada",
    "1HC": "Honda USA",
    "1NJ": "Nissan USA",
    "JFW": "Fuji Heavy Industries",
    "JSW": "Suzuki",
    "3G2": "General Motors Mexico",
    "4FT": "Mazda USA",
    "3H8": "Honda Mexico",
    "3GG": "General Motors Mexico",
    "3HD": "Honda Mexico",
    "4TS": "Toyota",
    "1LK": "Lincoln USA",
    "JMW": "Mazda",
    "2GY": "General Motors Canada",
    "4TM": "Toyota",
    "5LR": "Lincoln",
    "3NJ": "Nissan Mexico",
    "1HB": "Honda USA",
    "3NZ": "Nissan Mexico",
    "JN1": "Nissan",
    "5FU": "Honda USA-Alabama",
    "XSE": 'IMZ-Ural Ltd. "Russian motorcycles", Russia',
    "XTB": 'JSC "Moskvich" - the Moscow Automobile Plant, Russia',
    "XTF": 'JSC "Golitsyn Bus Plant" (HolAZ), Russia',
    "XTJ": 'JSC "Serpukhov Automobile Plant" ( "SeAZ"), Russia',
    "XTK": 'Izhevsk Automobile Plant ("IzhAvto"), Russia',
    "XTP": 'JSC "Metrovagonmash" (until 1992 - "Mytyschenskyy engineering plant" or MMP), Russia',
    "XTU": 'JSC "trolza" (fully Closed Joint Stock Company "trolza"), Russia',
    "XTZ": 'Car Plant. IA Likhachev, Russia',
    "XUS": 'Nyzhehorodets, Russia',
    "XVD": 'SemAR, Russia',
    "XVG": 'Company "Michurinsk bus" (Michurinsk avtoremontnыy plant Marz), Russia',
    "XWF": 'Avtotor - a company producing cars in Kaliningrad, Russia',
    "XWK": 'Izhevsk Automobile Plant ("IzhAvto"), Russia',
    "XWN": 'Armor Group, Russia',
    "X06": 'DYSA Auto, Russia',
    "X08": 'Myhnevskyy RMZ, Russia',
    "X0C": 'TagAZ, Taganrog, Russia',
    "X0J": 'Company "Mercator Servis ST", Russia',
    "X0P": 'Company "Perspective-K", Kazan, Russia',
    "X0T": 'MZ "TONAR" Orekhovo-Zuevo, Russia',
    "X0Y": 'Rodnikovskoe Machine Works, Russia',
    "X1A": 'HZSA, Nizhny Novgorod, Russia',
    "X1F": 'NEFAZ, Neftekamsk, Russia',
    "X1J": 'KZAP, Krasnoyarsk, Russia',
    "X1L": 'TMZ, Tavda, Russia',
    "X1P": 'UralAZ, Miass, Russia',
    "X1E": 'KAvZ, Kurgan, Russia',
    "XSG": 'Odessa car assembly plant ODAZ, Ukraine',
    "XSL": 'Lvov factory motorcycles, Ukraine',
    "XSP": 'Kyiv Motorcycle Plant, Ukraine',
    "XSW": 'JOINT "5 Kiev car repair PLANT", Ukraine',
    "XTD": 'Lutsk Automobile Plant, JSC, Ukraine',
    "XTE": 'PJSC Zaporizhia Automobile Plant (JSC "ZAZ"), Ukraine',
    "XTG": 'Ltd. "Kherson car assembly plant" Anto-Rus "(Antorus), Ukraine',
    "XTV": 'Lugansk Car Assembly Plant, Ukraine',
    "XTW": 'Lviv Bus Plant (LAZ), Ukraine',
    "XTX": 'Odessa car assembly plant ODAZ, Ukraine',
    "X1C": 'Kremenchug Automobile Plant, Ukraine',
    "XTM": 'Minsk Automobile Plant (MAZ), Minsk, Belarus',
    "X1R": 'BelAZ, Zhodino, Belarus',
    "XWW": 'Asia-Auto, Ust-Kamenogorsk, Kazakhstan',
    "X1D": 'RAF, Riga, Latvia',
    "X1S": 'Zid, Kovrov, Russia',
    "X1V": 'Kuban, Krasnodar, Russia',
    "X1W": 'SZAP, Stavropol, Russia',
    "X1X": 'Kupava, Minsk, Belarus',
    "X3W": '"Betsema", Krasnogorsk, Russia',
    "X3Z": 'Resurrection plant "Mashynostroytel", Voskresensk, Russia',
    "X4K": 'VAP "Volzhanin", Volzhsky, Russia',
    "X52": 'Company "Transles", Khimki, Russia',
    "X5C": 'LLC "Trailer", Stupino, Russia',
    "X5F": 'OJSC "Hydraulic lifter vehicles», St. Petersburg, Russia',
    "X5T": 'OJSC "41 central plant zheleznodorozhnoy technics", Tomilino, Russia',
    "X6F": 'Company "Spector Motors", v. Bratovschyna (Moscow region), Russia',
    "X7D": 'RosLada, Syzran, Russia',
    "X7T": 'CHAZ, Chernihiv, Ukraine',
    "X8U": 'Scania-Peter, Saint-Petersburg, Russia',
    "X9L": 'GM-AVTOVAZ, Togliatti (Samara Region), Russia',
    "X9N": 'Company "Samotlor-NN", Nizhny Novgorod, Russia',
    "X9U": 'LLC "Almanac", Nizhny Novgorod, Russia',
    "X9X": 'LLC "Autotrade-12", s. Novoharytonovo (Moscow region), Russia',
    "Y3B": 'BelAZ, Zhodino, Belarus',
    "Y3C": 'MoAZ, Mogilev, Belarus',
    "Y3J": 'BKM, Minsk, Belarus',
    "Y4F": 'Ford Union Minsk, Abchak (Belarus)',
    "Y6A": 'AutoKrAZ, Ukraine, Kremenchug',
    "Y6J": 'Repair plant Cherkasy, Cherkasy, Ukraine',
    "Y6L": 'LuAZ, Lutsk, Ukraine',
    "Y6R": 'Kherson car assembly factory «Anto-Rus", Kherson, Ukraine',
    "Y6V": 'FDI Kitpred, Kyiv, Ukraine',
    "Y69": 'Bohdan SpecAutomotive, Cherkasy, Ukraine /  Budmash, Kyiv, Ukraine / TITAL, Kyiv, Ukraine',
    "Y7A": 'AutoKrAZ, Ukraine, Kremenchug',
    "Y7B": 'Cherkasy Bus, Ukraine, Cherkasy ',
    "Y7C": 'Kremenchuk Car Assembly Plant, Kremenchuk, Ukraine',
    "Y7F": 'BAZ, Boryspil, Ukraine',
    "Y7K": 'CMH, Kyiv, Ukraine',
    "Y79": 'HalAZ, Lviv, Ukraine',
    "Y8A": 'Lviv Bus Plant (LAZ), Ukraine',
    "Y89": 'Yuzhmash,Dnipropetrovsk, Ukraine',
    "Z7C": '"Louis", Nizhny Novgorod, Russia',
    "Z7G": 'LLC "Sollers-Yelabuga», Yelabuga, Russia',
    "Z7T": 'RoAZ, Rostov-on-Don, Russia',
    "Z7Y": '"Artan", Nizhny Novgorod, Russia',
    "Z9Z": 'OOO "United Auto Group", Izhevsk, Russia',
    "X89": 'Little xUSSR factories',
    "Y39": 'Little xUSSR factories'
};
exports.default = manuf;
//# sourceMappingURL=manufactures.js.map